import { resolveDoorAlarmScheduleLabel } from './doorAlarmScheduleUtils';
import { getDevicesFromAllocations } from './getDevicesFromAllocation';
import { DeviceBatteryStatusType, DeviceBatteryStatuses } from 'src/constants/ButtonQa';
import { CareType, CareTypeLabelsAbbreviated } from 'src/constants/CareTypes';
import { DeviceAllocation, Door, Unit } from 'src/store/sageAdminApi';

export const getDoorDisplay = (door?: Door): string => {
    if (!door) {
        return '';
    }
    const { doorAlarmSchedule, unit } = door || {};

    let displayedItems = [];
    const doorUnit = unit?.displayName || '';
    doorUnit && displayedItems.push(doorUnit);
    doorAlarmSchedule &&
        displayedItems.push(resolveDoorAlarmScheduleLabel(door, doorAlarmSchedule));

    return displayedItems.join(' | ');
};

export const getUnitDisplay = (unit?: Unit): string => {
    if (!unit) {
        return '';
    }

    const { displayName, careType, ward } = unit;

    const careTypeValue = careType || ward;

    let displayedItems = [];
    careTypeValue && displayedItems.push(CareTypeLabelsAbbreviated[careTypeValue as CareType]);
    displayName && displayedItems.push(displayName);

    return displayedItems.join(' | ');
};

export function resolveBatteryStatusForButtonQa(
    batteryLevel: number | undefined
): DeviceBatteryStatusType {
    if (batteryLevel === -1 || batteryLevel === undefined) return DeviceBatteryStatuses.Unknown;
    if (batteryLevel < 80) return DeviceBatteryStatuses.LowBattery;
    return DeviceBatteryStatuses.Normal;
}

export function resolveBatteryStatusForCommunityDisplay(
    batteryLevel: number | undefined
): DeviceBatteryStatusType {
    if (batteryLevel === -1 || batteryLevel === undefined) return DeviceBatteryStatuses.Unknown;
    if (batteryLevel < 20) return DeviceBatteryStatuses.LowBattery;
    return DeviceBatteryStatuses.Normal;
}

/**
 * Returns the number of the unit's devices with a low battery so a
 * "Replace Battery (N)" indicator can reflect how many need attention.
 */
export function getLowBatteryDeviceCountFromMap(
    allocations: DeviceAllocation[] | undefined,
    batteryLevelsMap: Map<string, number>
): number {
    const { devices } = getDevicesFromAllocations(allocations || []);

    return devices.filter((device) => {
        const level = device?.id ? batteryLevelsMap.get(device.id) : undefined;
        return resolveBatteryStatusForCommunityDisplay(level) === DeviceBatteryStatuses.LowBattery;
    }).length;
}

export function hasCareConfirmationDevice(allocations: DeviceAllocation[] = []): boolean {
    return allocations.some(
        (allocation) =>
            !allocation.isSilent &&
            !allocation.isCheckIn &&
            (allocation.allocationType === 'BUTTON' ||
                allocation.allocationType === 'CARE_CONFIRMATION_BUTTON' ||
                allocation.allocationType === 'UNIVERSAL_TRANSMITTER_BUTTON')
    );
}
